import { Box, Container, Stack, Text, Link, HStack } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box bg="oxygon.dark.200" py={10}>
      <Container maxW="container.xl">
        <Stack
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          spacing={4}
        >
          <Text color="gray.400">
            {new Date().getFullYear()} Virtual Golf Society. All rights
            reserved.
          </Text>
          <HStack spacing={4}>
            <Link href="/terms" color="gray.400">
              Terms
            </Link>
            <Link href="/privacy" color="gray.400">
              Privacy
            </Link>
          </HStack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
